/* eslint-disable react/function-component-definition */
/* eslint-disable react-hooks/exhaustive-deps */

'use client'

import styled from 'styled-components'
import { useEffect } from 'react'
import SuccessThumbsUp from '@public/images/successThumbsUp.svg'
import SuccessThumbsUpWithHeart from '@public/images/successThumbsUpWithHeart.svg'

interface SuccessMessageContainerWrapperProps {
  isMobile: boolean
}

export default function SuccessMessageContainer({ isMobile, handleClose }) {
  useEffect(() => {
    if (!isMobile) {
      return
    }
    const timer = setTimeout(() => {
      handleClose()
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <SuccessMessageContainerWrapper isMobile={isMobile}>
      <StyledDiv>
        <StyledSuccessIcon />
        <StyledSuccessIconWithHeart />
      </StyledDiv>
      <StyledP>Thank you for reaching out.</StyledP>
      <StyledP>We’ll be in touch soon!</StyledP>
      {!isMobile && <StyledButton onClick={handleClose}>Okay, got it</StyledButton>}
    </SuccessMessageContainerWrapper>
  )
}

const SuccessMessageContainerWrapper = styled.div<SuccessMessageContainerWrapperProps>`
  ${props =>
    props.isMobile &&
    `
    position : fixed;
    bottom: 0;
    width: 100%;
    height: 100%;
    `};

  left: 0;
  padding: 14px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const StyledP = styled.p`
  margin: 0;
`

const StyledButton = styled.button`
  color: #040222;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  background: #fff;
  margin-top: 40px;
  padding: 8px 16px;
  border: 1px solid #040222;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #f8f7fc;
  }
  &:active {
    background: #e7e7f0;
  }
`

const StyledSuccessIcon = styled(SuccessThumbsUp)`
  position: absolute;
  left: 0;
  opacity: 0;
  animation-name: thumbsup;
  animation-duration: 0.4s;
  animation-timing-function: cubic-bezier(0.7, -0.4, 1, 1);

  @keyframes thumbsup {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`

const StyledSuccessIconWithHeart = styled(SuccessThumbsUpWithHeart)`
  position: absolute;
  left: 0px;

  animation-name: thumbsup;
  animation-timing-function: cubic-bezier(0.7, -0.4, 1, 1);
  animation-duration: 0.4s;

  @keyframes thumbsup {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

const StyledDiv = styled.div`
  position: relative;
  width: 90px;
  height: 90px;
  margin-bottom: 24px;
`
